const RETURN_URL_KEY = 'returnUrl';
const RETURN_URL_USER_ID_KEY = 'returnUrlUserId';

export function saveReturnUrl(returnUrl: string, userId: string | null): void {
  try {
    const parsedUrl = new URL(returnUrl, window.location.origin);

    if (parsedUrl.origin !== window.location.origin) {
      return;
    }

    sessionStorage.setItem(
      RETURN_URL_KEY,
      `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
    );

    if (userId) {
      sessionStorage.setItem(RETURN_URL_USER_ID_KEY, userId);
    } else {
      sessionStorage.removeItem(RETURN_URL_USER_ID_KEY);
    }
  } catch {
    sessionStorage.removeItem(RETURN_URL_KEY);
    sessionStorage.removeItem(RETURN_URL_USER_ID_KEY);
  }
}

export function consumeReturnUrl(userId: string): string | null {
  const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
  const returnUrlUserId = sessionStorage.getItem(RETURN_URL_USER_ID_KEY);

  sessionStorage.removeItem(RETURN_URL_KEY);
  sessionStorage.removeItem(RETURN_URL_USER_ID_KEY);

  if (!returnUrl || !returnUrlUserId || returnUrlUserId !== userId) {
    return null;
  }

  try {
    const parsedUrl = new URL(returnUrl, window.location.origin);

    if (parsedUrl.origin !== window.location.origin) {
      return null;
    }

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch {
    return null;
  }
}
